module.exports = __webpack_public_path__ + "media/images/mypage/icon/black/ico_suitcase-5f29d1ee31adacc642c4e9077d2d7ef7.svg";